module.exports = __webpack_public_path__ + "static/media/calendar_2.f875ba21.svg";